export const defaultSplitLine = {
  show: true,
  lineStyle: {
    color: "rgba(128, 128, 128, 0.2)",
    width: 1,
    type: "solid" as const,
  },
};
